<template>
  <button
    class="bookmark-button"
    @click="toggleBookmark"
  >
    <icon
      v-if="!hasBookmark"
      name="star"
    ></icon>
    <icon
      v-else
      name="star-filled"
    ></icon>
  </button>
</template>

<script>
import Icon from '@/components/singletons/icon';
import BookmarksMixin from '@/mixins/bookmarks';

export default {
  components: {
    Icon,
  },
  mixins: [BookmarksMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    flashcardId() {
      return this.flashcard?.id;
    },
    categoryId() {
      return this.category?.id;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
